import { responseSchema } from '../response-schema';
export var getFormattedSchemas = function (arrayOfRequestItems) {
    return arrayOfRequestItems.map(function () { return responseSchema; });
};
